/* AnnouncementBanners.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./AnnouncementBanners.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Flex } from '@atlaskit/primitives/compiled';
import { AnnouncementBannerItem } from './AnnouncementBannerItem';
var boxStyles = {
  default: "_ca0qu2gc _19bvu2gc _u5f3u2gc _n3tdu2gc _15a5nqa1 _uwhke4h9 _1i53muej"
};
export function AnnouncementBanners(_ref) {
  var banners = _ref.banners;
  if (banners.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: boxStyles.default,
    direction: "column",
    gap: "space.100"
  }, banners.map(function (banner) {
    return /*#__PURE__*/React.createElement(AnnouncementBannerItem, {
      key: banner.id,
      text: banner.text,
      onClose: banner.onClose
    });
  }));
}